import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ひとつのライフサイクル（仕様 §8.5）— 全台帳で同じ口を使う。
export const lifecycleApi = {
  state: (register, itemId) => axios.get(`${API}/item-lifecycle/${register}/${itemId}`)
    .then((r) => r.data),
  act: (register, itemId, action, body) => axios
    .post(`${API}/item-lifecycle/${register}/${itemId}/${action}`, body).then((r) => r.data),
  // 組込先の設備（既存の設備台帳の口をそのまま使う）
  equipment: () => axios.get(`${API}/mfg/equipment`).then((r) => r.data || []).catch(() => []),
};

export default lifecycleApi;
